import { useMemo } from "react";
import { RadioSwitch } from "../Inputs/RadioSwitch/RadioSwitch";
import { Controller, useFormContext } from "react-hook-form";
import { type HousingSearchForm } from "../../types/housingSAFormTypes";
import { NumberSystem, TemperatureUnit } from "../../types/types";
import { type WithTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import { type ItemDef } from "~/common/types";

interface Props {
  className?: string;
}

export const UnitSwitch = ({ className }: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext<HousingSearchForm>();
  const options: ItemDef[] = useMemo(() => getDimensionOptions(t), [t]);

  return (
    <Controller
      control={control}
      name={"dimensionUnit"}
      render={({ field: { value, onChange, onBlur } }) => (
        <RadioSwitch
          label={t("common.measureSystem.units")}
          className={className}
          value={value}
          options={options}
          onChange={(value) => onChange(value)}
        />
      )}
    />
  );
};

export const getDimensionOptions = (t: WithTranslation["t"]) => {
  return [
    {
      code: NumberSystem.Metric,
      label: t("common.measureSystem.metric"),
    },
    {
      code: NumberSystem.Imperial,
      label: t("common.measureSystem.imperial"),
    },
  ];
};
export const TemperatureSwitch = ({ className }: Props) => {
  const { control } = useFormContext<HousingSearchForm>();
  const options: ItemDef[] = useMemo(getTemperatureOptions, []);

  return (
    <Controller
      control={control}
      name={"temperatureUnit"}
      render={({ field: { value, onChange, onBlur } }) => (
        <RadioSwitch className={className} value={value} options={options} onChange={onChange} />
      )}
    />
  );
};

export const getTemperatureOptions = () => {
  return [
    {
      code: TemperatureUnit.Celsius,
      label: "°C",
    },
    {
      code: TemperatureUnit.Fahrenheit,
      label: "°F",
    },
  ];
};
